import React from "react";
import Skeleton from "./Skeleton";

const TicketOrderLoader = () => {
  return (
    <div className="border border-slate-100 rounded-md h-40 flex items-center p-5 gap-4">
      <Skeleton height={120} width={200} />
      <div className="h-full space-y-4">
        <Skeleton height={25} width={200} />
        <div className="space-y-1">
          <Skeleton height={13} width={400} />
          <Skeleton height={13} width={400} />
          <Skeleton height={13} width={200} />
        </div>
      </div>
    </div>
  );
};

export default TicketOrderLoader;
